import { User } from '@/api/types';

/** Mirrors backend User::isMedia(). */
export function isMedia(user: User): boolean {
    return user.access === 1;
}

/** Mirrors backend User::isStaff(). */
export function isStaff(user: User): boolean {
    return user.access >= 2;
}

/** Mirrors backend User::isOwned(). */
export function hasBasicAccess(user: User): boolean {
    return user.owned || isMedia(user) || isStaff(user);
}

/** Mirrors backend User::isOwnedAdvanced(). */
export function hasAdvancedAccess(user: User): boolean {
    return user.owned_advanced || isMedia(user) || isStaff(user);
}

/** True when the user effectively has both packages (paid or staff/media role). */
export function ownsBothPackages(user: User): boolean {
    return hasBasicAccess(user) && hasAdvancedAccess(user);
}
